import axios from "axios";
import FileDownload from "js-file-download";

import { HOSTNAME, NEW_HOST_URL, PUBLISHER_URL } from "../../config/envConfig";
import { fetch } from "../../utils";

export const getVideoGridStates = (data) =>
  fetch(`${NEW_HOST_URL}/streams/get`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const getSportsDetails = (data) =>
  fetch(`${NEW_HOST_URL}/get_created_sports`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const downloadVideo = (newVideoUrl) => {
  fetch(newVideoUrl, {
    url: newVideoUrl,
    responseType: "blob",
    headers: {
      referer: `https://staging.toch.ai`,
    },
  })
    .then((response) => {
      FileDownload(response.data, `video.mp4`);
    })
    .catch((err) => {});
};

export const getUserDetails = (data) =>
  fetch(`${NEW_HOST_URL}/get_invite_user/${localStorage.getItem("__uid")}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const getUsersDetails = (data) =>
  fetch(`${NEW_HOST_URL}/get_all_users/${localStorage.getItem("__uid")}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const getStreamDetail = (data) => {
  const queryParams = new URLSearchParams({ entityId: data.entityId }).toString();
  return fetch(`${NEW_HOST_URL}/stream/get/${data.id}?${queryParams}`, {
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};
export const getBulkData = (data) => {
  return fetch(`${NEW_HOST_URL}/fetch_bulk_data`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const getAllClips = (
  {
    id,
    limit,
    pageNo,
    filters,
    dateRange,
    sort,
    type,
    search,
    aspectRatio,
    webhookPublish,
    isManualUpload,
    skipCount,
    clipType,
    page,
    isAddedToClipsPage,
    entityId,
  },
  data,
) => {
  return fetch(
    `${NEW_HOST_URL}/get/clips/${id}?limit=${limit}&pageNo=${pageNo}&filters=${JSON.stringify(
      filters,
    )}&daterange=${JSON.stringify(dateRange)}&sort=${JSON.stringify(
      sort,
    )}&clipType=${clipType}&type=${type}&search=${search}&aspectRatio=${aspectRatio}&webhookPublish=${webhookPublish}&isManualUpload=${isManualUpload}&skipCount=${
      skipCount || ""
    }&entityId=${entityId}&page=${page}&isAddedToClipsPage=${isAddedToClipsPage}`,
    {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("authToken"),
      },
    },
  )
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const getSingleStream = ({ id }) => {
  return fetch(`${NEW_HOST_URL}/streams/detail/${id}`, {
    method: "GET",
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getOrgDetails = (data) => {
  const queryParams = new URLSearchParams(data).toString();
  return fetch(`${NEW_HOST_URL}/organizations?${queryParams}`, {
    method: "GET",
    headers: {
      Authorization: localStorage.getItem("authToken"),
      "Content-Type": "application/json",
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const addNewUser = (data) => {
  return fetch(`${NEW_HOST_URL}/organization/create`, {
    method: "POST",
    headers: {
      Authorization: localStorage.getItem("authToken"),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const updateOrgDetails = ({ id, ...data }) => {
  return fetch(`${NEW_HOST_URL}/organization/update/${id}`, {
    method: "POST",
    headers: {
      Authorization: localStorage.getItem("authToken"),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteClient = (data) => {
  return fetch(`${NEW_HOST_URL}/organization/${data}`, {
    method: "DELETE",
    // headers: {
    //   Authorization: localStorage.getItem("authToken"),
    //   "Content-Type": "application/json",
    // },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getTrimClip = (data) =>
  fetch(`${NEW_HOST_URL}/create_live_video_clips`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      // Authorization: localStorage.getItem("id_token"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });

export const getUploadPicture = (data) => {
  return fetch(`${NEW_HOST_URL}/upload`, {
    method: "post",
    headers: {
      Authorization: localStorage.getItem("authToken"),
    },
    body: data,
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const getImages = (data) => {
  return fetch(`${NEW_HOST_URL}/get_image`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const addAudio = (data) => {
  return fetch(`${NEW_HOST_URL}/add-audio`, {
    method: "post",
    headers: {
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};
export const addAudioToFolder = (data) => {
  return fetch(`${NEW_HOST_URL}/upload-audio`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const updatesftp = (data) => {
  return fetch(`${NEW_HOST_URL}/update_sftp`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getAudio = (data) => {
  return fetch(`${NEW_HOST_URL}/get-audio`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const addShow = (data) => {
  return fetch(`${NEW_HOST_URL}/shows/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const getShows = (data) => {
  return fetch(`${NEW_HOST_URL}/shows/get`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const deleteShows = (data) => {
  return fetch(`${NEW_HOST_URL}/shows/delete`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const editShow = (data) => {
  return fetch(`${NEW_HOST_URL}/shows/edit`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const addImages = (data) =>
  fetch(`${NEW_HOST_URL}/add_image`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });

export const getAddImages = (data) => {
  return fetch(`${NEW_HOST_URL}/image_text_overlay`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const addSlate = (data) => {
  return fetch(`${NEW_HOST_URL}/sony_create_advertise_video`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    //  body: data,
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const uploadSlate = ({ data }) => {
  return fetch(`${NEW_HOST_URL}/images/upload`, {
    method: "post",
    headers: {
      Authorization: localStorage.getItem("authToken"),
    },
    body: data,
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const showSlate = (data) => {
  return fetch(`${NEW_HOST_URL}/sony_get_advertisement`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const getTournaments = (data) =>
  fetch(`${NEW_HOST_URL}/stream/latest`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });

export const getStorage = (data) =>
  fetch(`${NEW_HOST_URL}/accounts/storage/get`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });

export const createStream = async (data) => {
  return fetch(`${NEW_HOST_URL}/streams/create`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const getTournamentsData = async (data) => {
  return fetch(`${NEW_HOST_URL}/get-tournaments`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const getCustomData = async ({ entityId }) => {
  return fetch(`${NEW_HOST_URL}/accounts/settings/${entityId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const fetchClipMetadata = async (payload) => {
  return fetch(`${NEW_HOST_URL}/fetch-clip-metadata`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(payload),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getBrightCoveToken = async (data) => {
  return fetch(`${NEW_HOST_URL}/access_token`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const getBrightCoveVideos = async (data) => {
  return fetch(`${NEW_HOST_URL}/getvideo_by_id`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const UploadClipInBrightCove = async (data) => {
  return fetch(`${NEW_HOST_URL}/publish/video/bright_cove`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const fetchFolderListFromBrightCove = async (data) => {
  return fetch(`${NEW_HOST_URL}/folder/list/bright_cove`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const fetchVideoUrlListFromBrightCove = async (data) => {
  return fetch(`${NEW_HOST_URL}/folder/url/list/bright_cove`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const getPlayersStreams = async (data) => {
  return fetch(`${NEW_HOST_URL}/get_player_by_streamid`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};
//get and search player with respect to event
export const getPlayersByEvents = async ({ event, userId, search, page_no }) => {
  return fetch(
    `${NEW_HOST_URL}/get_players_by_event?&event=${event}&userId=${userId}&search=${
      search === undefined ? "" : search
    }&page_no=${page_no}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  )
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const getPlayers = async (data) => {
  return fetch(`${NEW_HOST_URL}/get/team_by_ids`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const editStream = async (data) => {
  return fetch(`${NEW_HOST_URL}/streams/edit`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};
export const fancodeEdit = async (data) => {
  return fetch(`${NEW_HOST_URL}/fancode/edit`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};
export const addSport = async (data) => {
  return fetch(`${NEW_HOST_URL}/create/add_new_spport`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const updateSportsCategory = async (data) => {
  return fetch(`${NEW_HOST_URL}/update_sports_category`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const getEventsStreams = async (data) => {
  let url = `${NEW_HOST_URL}/get-clips-filter/${data.streamId}?category=${data.category}&clipType=${
    data.clipType
  }&isManualUpload=${data.isManualUpload}&entityId=${localStorage.getItem("entityId")}`;
  if (data.events) {
    url = url + `&events=${data.events}&clipRating=${data.clipRating}`;
  }
  return fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    // body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};
export const getEventsByCategory = async (data) => {
  return fetch(`${NEW_HOST_URL}/get_event_by_category`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const getFolders = ({ search, activePage, ...data }) => {
  return fetch(`${NEW_HOST_URL}/get-all-folders?&search=${search}&page_no=${activePage}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getClipsCount = async (
  { id, limit, pageNo, filters, dateRange, sort, type, search, aspectRatio, isManualUpload },
  data,
) => {
  return fetch(
    `${NEW_HOST_URL}/get_clip_count/${id}?limit=${limit}&pageNo=${pageNo}&filters=${JSON.stringify(
      filters,
    )}&daterange=${JSON.stringify(dateRange)}&sort=${JSON.stringify(
      sort,
    )}&type=${type}&search=${search}&aspectRatio=${aspectRatio}&isManualUpload=${isManualUpload}`,
    {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("authToken"),
      },
      body: JSON.stringify(data),
    },
  )
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const createFolder = (data) => {
  return fetch(`${NEW_HOST_URL}/folder`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const getRTMPChannel = (data) => {
  return fetch(`${NEW_HOST_URL}/rtmp/list_channel`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const updateRTMPState = (data) => {
  return fetch(`${NEW_HOST_URL}/rtmp/update_channel_state`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const getChannelDetails = (data) => {
  return fetch(`${NEW_HOST_URL}/rtmp/channel_details`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const updatertmpChannel = (data) => {
  return fetch(`${NEW_HOST_URL}/rtmp/configure_channel`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const updateFolder = ({ _id, ...data }) => {
  return fetch(`${NEW_HOST_URL}/update-folder/${_id}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const updateHighlightFolder = ({ _id, ...data }) => {
  return fetch(`${NEW_HOST_URL}/update-highlight-folder/${_id}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getAspectRatios = (data) => {
  return fetch(`${NEW_HOST_URL}/create_video_via_input_crop`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const deleteStreams = (data) => {
  return fetch(`${NEW_HOST_URL}/streams/delete`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const deleteEditedClip = (data) => {
  return fetch(`${NEW_HOST_URL}/sony_clips/delete_edited_clip`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteCategory = (data) => {
  return fetch(`${NEW_HOST_URL}/category/delete`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const deleteArchiveStream = (data) => {
  return fetch(`${NEW_HOST_URL}/delete-archive-streams`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const deleteArchiveClips = (data) => {
  return fetch(`${NEW_HOST_URL}/delete-archive-data`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const getArchiveClips = (data) => {
  return fetch(`${NEW_HOST_URL}/get-archive-data`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const getArchiveStream = (data) => {
  return fetch(`${NEW_HOST_URL}/get-archive-streams`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const getArchiveBulkData = (data) => {
  return fetch(`${NEW_HOST_URL}/archive_bulk_data`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const getBulkArchiveData = (data) => {
  return fetch(`${NEW_HOST_URL}/fetch_bulk_archive_data`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const restoreArchiveStream = (data) => {
  return fetch(`${NEW_HOST_URL}/restore-archive-streams`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const restoreArchivedStream = (data) => {
  return fetch(`${NEW_HOST_URL}/restore-archive-stream`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const restoreArchiveClips = (data) => {
  return fetch(`${NEW_HOST_URL}/restore-archive-data`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const getCopiedStreamCount = (data) => {
  return fetch(`${NEW_HOST_URL}/get-copied-stream-count/${data.streamId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const createHighlight = (data) => {
  return fetch(`${NEW_HOST_URL}/sony_promo_creation`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const getCustomFields = ({ entityId }) => {
  return fetch(`${NEW_HOST_URL}/accounts/settings/${entityId}`, {
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const deleteClip = (data) => {
  return fetch(`${NEW_HOST_URL}/sony_clips/delete_by_id`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const getPublishedClips = (data) => {
  return fetch(`${NEW_HOST_URL}/get-published-clips`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const createCustomFields = ({ entityId, field }, data) => {
  return fetch(`${NEW_HOST_URL}/setting_fields/${entityId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify({ field: field }),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteFolder = (id, data) => {
  return fetch(`${NEW_HOST_URL}/delete-folder/${id.id}`, {
    method: "Delete",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteAudio = (id, data) => {
  return fetch(`${NEW_HOST_URL}/delete-audio/${id}`, {
    method: "Delete",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const cropVideo = (data) => {
  return fetch(`${NEW_HOST_URL}/create_video_via_input_crop`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getVideoMetaData = (data) => {
  return fetch(`${NEW_HOST_URL}/get_video_metadata`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const verifySpecification = (data) => {
  return fetch(`${NEW_HOST_URL}/verify_specification`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteFields = (data) => {
  return fetch(`${NEW_HOST_URL}/delete/custom_fields`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const getSportsTeam = (data) => {
  return fetch(`${NEW_HOST_URL}/get/sport_teams`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const createTournament = (data) => {
  return fetch(`${NEW_HOST_URL}/create/tournament`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const addEvent = (data) => {
  return fetch(`${NEW_HOST_URL}/tag/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const createTeam = (data) => {
  return fetch(`${NEW_HOST_URL}/create/team`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const uploadHashtag = (data) => {
  return fetch(`${NEW_HOST_URL}/hashtag`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const createPlayer = (data) => {
  return fetch(`${NEW_HOST_URL}/create/add_new/player`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getHashtag = (data) => {
  return fetch(`${NEW_HOST_URL}/get_filter_hashtag`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getHoursConsumed = ({ userId, search, activePage }) => {
  return fetch(`${NEW_HOST_URL}/dash-steams-data-consumed?&userId=${userId}&search=${search}&page_no=${activePage}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteTournamentData = (data) => {
  return fetch(`${NEW_HOST_URL}/delete-tournament`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const deleteKeymoment = (data) => {
  return fetch(`${NEW_HOST_URL}/delete/admin_create_events`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const deleteTeam = (data) => {
  return fetch(`${NEW_HOST_URL}/delete/team`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const deletePlayers = (data) => {
  return fetch(`${NEW_HOST_URL}/delete/admin_create_player`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const createPreview = (data) => {
  return fetch(`${NEW_HOST_URL}/create-preview`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const clipCreatePreview = (data) => {
  return fetch(`${NEW_HOST_URL}/create-clip-preview`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const s3BucketPublish = (data) => {
  return fetch(`${NEW_HOST_URL}/s3_bucket_publish`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
// for viacom
export const uploadToThirdPartyS3Publish = (data) => {
  return fetch(`${NEW_HOST_URL}/third_party_bucket_publish`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const bulkS3BucketPublish = (data) => {
  return fetch(`${NEW_HOST_URL}/clips/bulk-s3-upload`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const jsonBucketPublish = (data) => {
  return fetch(`${NEW_HOST_URL}/json/s3_bucket_publish`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const sortHandVideo = (data) => {
  return fetch(`${NEW_HOST_URL}/generate-sorthand-video`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const deleteSlate = (data) => {
  return fetch(`${NEW_HOST_URL}/delete_slate_video`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

// Copy single or multiple clips API
export const copyClip = (data) => {
  return fetch(`${NEW_HOST_URL}/clips/copy-clips`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const editClip = (data) => {
  return fetch(`${NEW_HOST_URL}/sony_clips/edit`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const uploadClip = (data) => {
  return fetch(`${NEW_HOST_URL}/upload_clip`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const createRTMPChannel = (data) => {
  return fetch(`${NEW_HOST_URL}/rtmp/add_channel`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const publishClip = (data) => {
  return fetch(`${NEW_HOST_URL}/sony_clips/publish`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteImages = (data) => {
  return fetch(`${NEW_HOST_URL}/delete_image`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const shareOnSocialMedia = (data) => {
  return fetch(`${NEW_HOST_URL}/generate-html`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const cutCropVideo = (data) => {
  return fetch(`${NEW_HOST_URL}/create_trim_crop_clip`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const twitterShare = (data) => {
  return fetch(`${NEW_HOST_URL}/auth_twitter`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const youtubeShare = (data) => {
  return fetch(`${NEW_HOST_URL}/upload-youtube-video`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const deleteHashtag = (id) => {
  return fetch(`${NEW_HOST_URL}/hashtag/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("id_token"),
    },
    body: JSON.stringify(id),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const isValidStream = (data) => {
  return fetch(`${NEW_HOST_URL}/stream/validation`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const uploadStream = (data, config) => {
  axios
    .post(`${NEW_HOST_URL}/upload-stream`, data, config)
    .then((res) => {
      return res.data;
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const tagFilters = (data) => {
  return fetch(`${NEW_HOST_URL}/sony_clips/edit`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const singleClipDetails = (data) => {
  return fetch(`${NEW_HOST_URL}/sony_clips/clip_detail`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const saveInningData = (data) => {
  return fetch(`${NEW_HOST_URL}/save_inning_stream_data`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const updateClipDetails = (data) => {
  return fetch(`${NEW_HOST_URL}/sony_clips/update_by_id`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getPublicUrls = (data) => {
  return fetch(`${NEW_HOST_URL}/get/public-url`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const cropImage = (data) => {
  return fetch(`${NEW_HOST_URL}/crop_image`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const shareOnSocialMedias = (data) => {
  // return fetchUrlThirdParty(`https://app.ayrshare.com/api/post`, {
  //   method: "POST",
  //   headers: {
  //     "Content-Type": "application/json",
  //     Authorization: `Bearer ${BearerToken}`,
  //   },
  //   body: JSON.stringify(data),
  // })
  //   .then((res) => {
  //     return res.json();
  //   })
  //   .then((payload) => {
  //     return payload;
  //   })
  //   .catch((error) => {
  //
  //     throw error;
  //   });
  return axios({
    method: "post",
    url: `${PUBLISHER_URL}/proxy/ayrshare/post`,
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    data: JSON.stringify({ ...data, entityId: localStorage.getItem("entityId") }),
  })
    .then(async function (response) {
      return response;
    })
    .catch(function ({ response }) {
      return response;
    });
};

export const addSocialMediaData = (data) => {
  return fetch(`${NEW_HOST_URL}/add-social-media-data`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getSingleFolder = ({ id }) => {
  return fetch(`${NEW_HOST_URL}/folder/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getClipsByFolder = ({ search, pageNo, limit, id }) => {
  return fetch(`${NEW_HOST_URL}/folder/${id}?search=${search}&pageNo=${pageNo}&limit=${limit}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const clipListFolders = (data) => {
  return fetch(`${NEW_HOST_URL}/get_folders_by_clipId/${data.id}?search=${data.searchFolder}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const createStory = (data) => {
  return fetch(`${NEW_HOST_URL}/create-story`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const addStory = (data) => {
  return fetch(`${NEW_HOST_URL}/add-story`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const editWebStory = (data) => {
  return fetch(`${NEW_HOST_URL}/create-webstory`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const rePublishWebStory = (data) => {
  return fetch(`${NEW_HOST_URL}/republish-story`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const getStory = (data) => {
  return fetch(`${NEW_HOST_URL}/get-story`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const getStoryDetails = (data) => {
  return fetch(`${NEW_HOST_URL}/get-story-details`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const createServer = (data) => {
  return fetch(`${NEW_HOST_URL}/create_server`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("id_token"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteServer = (data) => {
  return fetch(`${NEW_HOST_URL}/delete-server/${data.serverId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("id_token"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const deleteRTMPChannel = (data) => {
  return fetch(`${NEW_HOST_URL}/rtmp/delete_channel/${data}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("id_token"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getAllInviteUser = ({ userId }) => {
  return fetch(`${NEW_HOST_URL}/get_all_invite_user/${userId}`, {
    method: "get",
    headers: {
      "Content-Type": "application/json",
      // Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getStoriesByOrgId = (payload) => {
  return fetch(`${NEW_HOST_URL}/get-stories-by-organization`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(payload),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      return error;
    });
};

export const getServerDetails = (data) => {
  return fetch(`${NEW_HOST_URL}/get-server`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("id_token"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getSportsValue = (data) => {
  return fetch(`${NEW_HOST_URL}/get/all_sport_value`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const mapStreams = (data) => {
  return fetch(`${NEW_HOST_URL}/group_streams/get`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const updateCustomField = ({ data: { field, entityId } }) => {
  return fetch(`${NEW_HOST_URL}/update-setting/${entityId}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(field),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const gropuMappingStreams = ({ mappingKey }) => {
  return fetch(`${NEW_HOST_URL}/stream/get/${mappingKey}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const gropuMappingClips = ({ mappingKey, ...data }) => {
  return fetch(`${NEW_HOST_URL}/sony_clips/get_groupclips/${mappingKey}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("id_token"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getFoldersById = ({
  limit,
  page_no,
  type,
  search,
  sortBy,
  aspectRatio,
  folderRating,
  category,
  tournaments,
  entityId,
}) => {
  return fetch(
    `${NEW_HOST_URL}/get_folders_by_entityId?limit=${limit}&page_no=${page_no}&type=${type}&search=${search}&sortBy=${sortBy}&aspectRatio=${aspectRatio}&folderRating=${folderRating}&category=${category}&tournaments=${tournaments}&entityId=${entityId}`,
    {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("authToken"),
      },
    },
  )
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getTournamentById = (data) => {
  return fetch(`${NEW_HOST_URL}/get-tournaments-by-id`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("id_token"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getGroupedStreams = ({ mappingKey }) => {
  return fetch(`${NEW_HOST_URL}/group_streams/detail/${mappingKey}`, {
    method: "get",
    headers: {
      "Content-Type": "application/json",
      // Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const generateAutoFlip = (data) => {
  return fetch(`${NEW_HOST_URL}/create_autoflip_video`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const updateTournament = (data) => {
  return fetch(`${NEW_HOST_URL}/update_tournament`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const streamExportJson = ({ id }) => {
  return fetch(`${NEW_HOST_URL}/export-publish-clips/${id}`, {
    method: "GET",
    headers: {
      Authorization: localStorage.getItem("id_token"),
    },
    //body: JSON.stringify(id),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const exportEventsJson = ({ id }) => {
  return fetch(`${NEW_HOST_URL}/export_events_json/${id}`, {
    method: "POST",
    headers: {
      Authorization: localStorage.getItem("id_token"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const exportStreamReport = (data) => {
  return fetch(`${NEW_HOST_URL}/stream/export/report`, {
    method: "POST",
    headers: {
      Authorization: localStorage.getItem("id_token"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const clipExportJson = (data) => {
  return fetch(`${NEW_HOST_URL}/export_clip_json`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("id_token"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const clipExportEDL = (data) => {
  return fetch(`${NEW_HOST_URL}/api/v3/export_edl`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("id_token"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const genrateNewClip = (data) => {
  return fetch(`${NEW_HOST_URL}/generate/clip`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const addBulkTournament = (data) => {
  return fetch(`${NEW_HOST_URL}/add_bulk_tournaments`, {
    method: "POST",
    body: data,
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const addTagThroughCSV = (data) => {
  return fetch(`${NEW_HOST_URL}/tag/upload-through-csv`, {
    method: "POST",
    body: data,
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const addBulkTeam = (data) => {
  return fetch(`${NEW_HOST_URL}/add_bulk_teams`, {
    method: "POST",
    body: data,
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getCropperVideoMetaData = (data) => {
  return fetch(`${NEW_HOST_URL}/get_video_metadata`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("id_token"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getVideoAspectRatio = (data) => {
  return fetch(`${HOSTNAME}/get_video_metadata`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("id_token"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const bucketCopy = (data) => {
  return fetch(`${NEW_HOST_URL}/bucket_to_bucket_copy`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const dumpOnS3 = (data) => {
  return fetch(`${NEW_HOST_URL}/dump_on_s3`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("id_token"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const copyClipToReviewer = (data) => {
  return fetch(`${NEW_HOST_URL}/copy_clip_to_reviewer`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("id_token"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const downloadClips = (data) => {
  return axios({
    url: data,
    method: "GET",
    responseType: "blob",
    headers: {
      referer: `https://staging.toch.ai`,
    },
  })
    .then((response) => {
      FileDownload(response.data, `video.mp4`);
      return response;
    })
    .catch((err) => {
      return err;
    });
};

export const downloadAllClips = (data) => {
  return fetch(`${NEW_HOST_URL}/get-remote-file-size`, {
    url: data,
    method: "POST",
    //responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("id_token"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const downloadAsZip = (data) => {
  return fetch(`${NEW_HOST_URL}/create-zip-url`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("id_token"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
// Api function for Audio FadeIn/Out
export const audiofadeInOut = (data) => {
  return fetch(`${NEW_HOST_URL}/apply/audio_transition`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getClipSizeByUrl = (data) => {
  return fetch(`${NEW_HOST_URL}/get-remote-file-size`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const streamLogs = (data) => {
  return fetch(`${NEW_HOST_URL}/get/logger-by-type`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("id_token"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const fileUpload = ({ data }) => {
  return fetch(`${NEW_HOST_URL}/file-upload`, {
    method: "POST",
    headers: {
      Authorization: localStorage.getItem("authToken"),
    },
    body: data,
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const uploadFileChunks = (data) => {
  return fetch(`${NEW_HOST_URL}/upload-chunck`, {
    method: "POST",
    headers: {
      Authorization: localStorage.getItem("authToken"),
    },
    body: data,
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};
export const getTimeLineDuration = (data) => {
  return fetch(`${NEW_HOST_URL}/timeline/duration`, {
    method: "POST",
    headers: {
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};
export const addThumbnail = (data) => {
  return fetch(`${NEW_HOST_URL}/clips/generate-thumbnail-from-video`, {
    method: "POST",
    headers: {
      Authorization: localStorage.getItem("authToken"),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};
export const GenerateVideoTitle = (data) => {
  return fetch(`${NEW_HOST_URL}/clips/generate-ai-title`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

// file: (binary)
// filename: UEFA_SuperCup2022V2ByDeepak2.zip
// userId: 3tBwdNb9s
export const uploadStoryTemplate = (data) => {
  return fetch(`${NEW_HOST_URL}/upload-story-template`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: data,
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};
// {
//   "status": 2
// }
export const getStoryTemplates = (data) => {
  return fetch(`${NEW_HOST_URL}/get-story-templates`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};
// {
//   "_id": "6246e3179b8acd4f33f2c5ed",
//   "url": "https://d1lw40p9dgniy0.cloudfront.net/vendor/video/mobile/video/v_video/1646660465_5258732/1646660465_5258732.mp4",
//   "category": "cricket"
// }
export const testStoryTemplate = (data) => {
  return fetch(`${NEW_HOST_URL}/test-story-template`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};
// {
//   "_id": "625d64ac790ec5eb1db3bec1",
//   "title": "test"
// }
export const moveStoryTemplate = (data) => {
  return fetch(`${NEW_HOST_URL}/move-story-template`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};
// {
//   "_id": "625d64ac790ec5eb1db3bec1"
// }
export const deleteStoryTemplate = (data) => {
  return fetch(`${NEW_HOST_URL}/delete-story-template`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const getCategoryConfiguration = (data) => {
  return fetch(`${NEW_HOST_URL}/category-configuration/${data.category}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};
export const updateCategoryConfiguration = (data) => {
  return fetch(`${NEW_HOST_URL}/update-category-configuration`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const copyStream = (data) => {
  //Api for Copy the Stream
  return fetch(`${NEW_HOST_URL}/copy_streams`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const applyLogoOnThumbnail = (data) => {
  //Api for adding logo on thumbnail
  return fetch(`${NEW_HOST_URL}/clips/apply_logo`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const overWriteClip = (data) => {
  //Api for overwriting clip with generated preview
  return fetch(`${NEW_HOST_URL}/overwrite-clip`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const trimandChangeSpeedClip = (data) => {
  //Api for Trim and Chnage Speed of Clip
  return fetch(`${NEW_HOST_URL}/live_video_clips`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const addTenant = (data) => {
  return fetch(`${NEW_HOST_URL}/client/create`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const getTenant = () => {
  return fetch(`${NEW_HOST_URL}/client/get`, {
    method: "GET",
    headers: {
      Authorization: localStorage.getItem("id_token"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const deleteTenant = (data) => {
  return fetch(`${NEW_HOST_URL}/client/delete`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};
export const updateTenant = (data) => {
  return fetch(`${NEW_HOST_URL}/client/update`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};
export const ftpPublish = (data) => {
  return fetch(`${PUBLISHER_URL}/api/v1/ftp.publish`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};
export const getftplist = (data) => {
  return fetch(`${PUBLISHER_URL}/api/v1/ftp.list`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};
export const getftpPublishedClips = (data) => {
  return fetch(`${NEW_HOST_URL}/list_ftp_publish/${data.id}`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};
export const getClipsData = (data) => {
  //Api for get Clips data by ids
  return fetch(`${NEW_HOST_URL}/get_clip_data`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

//export clips XML file
export const clipExportXml = async (data) => {
  return fetch(`${NEW_HOST_URL}/export_clip_xml`, {
    method: "POST",
    headers: {
      Authorization: localStorage.getItem("id_token"),
      "Content-Type": "application/json; charset=UTF-8",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const getPreAssignedUrl = (data) => {
  return fetch(`${NEW_HOST_URL}/presigned_url`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getContentType = (data) => {
  return fetch(`${NEW_HOST_URL}/get-mime-type`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getPresignedUrl = (data) => {
  return fetch(`${NEW_HOST_URL}/get-presigned-url`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const createS3PresignedURl = (data) => {
  return fetch(`${NEW_HOST_URL}/create-presigned-url`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const getQueueSetting = (data) => {
  return fetch(`${NEW_HOST_URL}/get_firestore_config/${data}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const updateQueueSetting = (data) => {
  return fetch(`${NEW_HOST_URL}/update_firestore_config`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getTrimClipV2 = (data) => {
  return fetch(`${NEW_HOST_URL}/create_live_video_clips_v2`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const reProcessVideo = (data) => {
  return fetch(`${NEW_HOST_URL}/reprocess-video`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getStreamCountByFilter = (data) => {
  return fetch(`${NEW_HOST_URL}/stream/filter-count`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getClipsByFilter = (data) => {
  return fetch(`${NEW_HOST_URL}/clips/list_by_filter`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const initialteRequestForHLSToMP4 = (data) => {
  return fetch(`${NEW_HOST_URL}/initiate_request`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getHLSToMP4 = ({ streamId }) => {
  return fetch(`${NEW_HOST_URL}/get_hls_to_mp4/${streamId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const getMediaTemplate = (data) => {
  const pageNo = data.pageNo !== undefined ? data.pageNo : "";
  const limit = data.limit !== undefined ? data.limit : "";
  const outputTemplateType = data.outputTemplateType !== undefined ? data.outputTemplateType : "";
  return fetch(
    `${NEW_HOST_URL}/medialive_output_template/${data.entityId}?pageNo=${pageNo}&limit=${limit}&outputTemplateType=${outputTemplateType}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("authToken"),
      },
    },
  )
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteHlsToMp4 = ({ streamId }) => {
  return fetch(`${NEW_HOST_URL}/delete_hls_to_mp4_data/${streamId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const updateVideoData = (data) => {
  return fetch(`${NEW_HOST_URL}/stream/update`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const reorderStream = (data) => {
  return fetch(`${NEW_HOST_URL}/api/v1/streams/reorder`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getInternalStatus = (data) => {
  return fetch(`${NEW_HOST_URL}/api/v1/zee/message/get`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const exportStreamCsv = (data) => {
  return fetch(`${NEW_HOST_URL}/streams/exports_stream_csv`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const editReservedChannel = (data) => {
  return fetch(`${NEW_HOST_URL}/reserved/update_channel`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const createReservedChannle = (data) => {
  return fetch(`${NEW_HOST_URL}/reserved/add_channel  `, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const checkReservedChannelStatus = (data) => {
  return fetch(`${NEW_HOST_URL}/check_reserved_channel_status  `, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const listReservedChannel = (data) => {
  return fetch(`${NEW_HOST_URL}/reserved/list_channel  `, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteReservedChannel = (data) => {
  return fetch(`${NEW_HOST_URL}/reserved/delete_channel/${data}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteMediaTemplate = (id) => {
  return fetch(`${NEW_HOST_URL}/delete_medialive_output_template/${id}`, {
    method: "Delete",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getCsvData = (data) => {
  return fetch(`${NEW_HOST_URL}/streams/download_csv_data`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const addMediaTemplate = (data) => {
  return fetch(`${NEW_HOST_URL}/create_medialive_output_template`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const restartServer = (data) => {
  return fetch(`${NEW_HOST_URL}/api/v1/zee/restart-ai-process`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const editMediaTemplate = (data) => {
  return fetch(`${NEW_HOST_URL}/edit_medialive_output_template`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getDownloadStatus = (data) => {
  return fetch(`${NEW_HOST_URL}/getDownloadStatus`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const checkAutoAssignRating = (data) => {
  return fetch(`${NEW_HOST_URL}/check-rating`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("id_token"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getAllRatingRules = (data) => {
  return fetch(`${NEW_HOST_URL}/get-all-rating-rule`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("id_token"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const generateUserPermissionsReport = (data) => {
  return fetch(`${NEW_HOST_URL}/user/permissions-report`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const advanceEditorIllusto = (data) => {
  return fetch(`${NEW_HOST_URL}/advanceEditorIllusto`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const getIllustoClipStatus = (data) => {
  return fetch(`${NEW_HOST_URL}/getIllustoClipStatus`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const getVerticalRequestDetails = (data) => {
  return fetch(`${NEW_HOST_URL}/get-queue-states`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const submitSecretValue = (data) => {
  return fetch(`${NEW_HOST_URL}/process_srt_encryption`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const fetchSecretValues = (data) => {
  return fetch(`${NEW_HOST_URL}/get_all_srt_encryption?page_no=${data.page_no}&limit=${data.limit}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const deleteSecretValue = (data) => {
  return fetch(`${NEW_HOST_URL}/process_srt_encryption`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const updateRolePermission = (data) => {
  return fetch(`${NEW_HOST_URL}/update-role-permission`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getSingleOrganizationById = (data) => {
  return fetch(`${NEW_HOST_URL}/organizaton/user/${data?.orgnizationId}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const createGroup = (data) => {
  return fetch(`${NEW_HOST_URL}/organization/${data?.organizationId}/group/create/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      name: data?.name,
      users: data?.users,
    }),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getOrganizationGroups = (data) => {
  return fetch(`${NEW_HOST_URL}/organization/${data?.organizationId}/group/all/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      getSubOrgGroups: !!data?.getSubOrgGroups,
    }),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteGroup = (data) => {
  return fetch(`${NEW_HOST_URL}/organization/${data?.organizationId}/group/${data?.groupId}/`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const editGroup = (data) => {
  return fetch(`${NEW_HOST_URL}/organization/${data?.organizationId}/group/${data?.groupId}/`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify({
      name: data?.name,
      users: data?.users,
    }),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getGroupUsers = (data) => {
  return fetch(`${NEW_HOST_URL}/organization/${data?.organizationId}/group/${data?.groupId}/users/`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getAllOrganizationUsers = (data, role) => {
  const roleValue = role ? role : "";
  return fetch(`${NEW_HOST_URL}/organization/users?role=${roleValue}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getCreateCategory = (data) => {
  return fetch(`${NEW_HOST_URL}/category/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getAllCategory = (data) => {
  return fetch(`${NEW_HOST_URL}/category`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getAllTagsById = (data) => {
  return fetch(`${NEW_HOST_URL}/tags`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const deleteTagsById = (data) => {
  return fetch(`${NEW_HOST_URL}/tags/delete`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getCreateTeams = (data) => {
  return fetch(`${NEW_HOST_URL}/team/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getAllTeams = (data) => {
  return fetch(`${NEW_HOST_URL}/teams`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteTeamById = (data) => {
  return fetch(`${NEW_HOST_URL}/team/delete`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const editTeamById = (data) => {
  return fetch(`${NEW_HOST_URL}/team/update`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const assignCategoryToOrganization = (data) => {
  return fetch(`${NEW_HOST_URL}/category/assign-to-organization`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getCreateTournament = (data) => {
  return fetch(`${NEW_HOST_URL}/tournament/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const getAllTournament = (data) => {
  return fetch(`${NEW_HOST_URL}/tournaments`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getEditTournament = (data) => {
  return fetch(`${NEW_HOST_URL}/tournament/update`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getDeleteTournament = (data) => {
  return fetch(`${NEW_HOST_URL}/tournament/delete`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getTotalTeams = (data) => {
  return fetch(`${NEW_HOST_URL}/teams/all`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getGraphData = (data) => {
  return fetch(`${NEW_HOST_URL}/medialive/health-logs`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const getAlerts = (data) => {
  return fetch(`${NEW_HOST_URL}/get-medialive/health-alerts`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getStreamsListByUrl = (data) => {
  return fetch(`${NEW_HOST_URL}/streams-by-url?url=${data.url}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const createSocialMediaCaption = (data) => {
  return fetch(`${NEW_HOST_URL}/api/v3/social_media_captions/clips`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const getRunningStreamTemplates = (data) => {
  return fetch(
    `${NEW_HOST_URL}/medialive/stream-templates/running?templateType=${data.templateType}&entityId=${data.entityId}&page_no=${data.pageNo}  `,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("authToken"),
      },
    },
  )
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const streamClipsExportXlsx = ({ id }) => {
  return fetch(`${NEW_HOST_URL}/export-stream-clips/${id}`, {
    method: "GET",
    headers: {
      Authorization: localStorage.getItem("id_token"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const validateStreamAccess = (data) => {
  return fetch(`${NEW_HOST_URL}/validate-stream`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const updateCategory = (data) => {
  return fetch(`${NEW_HOST_URL}/update/category`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      return response.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const downloadClipZipPackage = (data) => {
  return fetch(`${NEW_HOST_URL}/archive_download`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const fetchTemplateConfig = async () => {
  return fetch(`${NEW_HOST_URL}/template-config`, {
    method: "GET",
    headers: {
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const updateTemplateConfig = async (data) => {
  return fetch(`${NEW_HOST_URL}/template-config`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const publishZeeThumbnails = async (data) => {
  return fetch(`${NEW_HOST_URL}/publish-zee-thumbnails`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getQueueProcessStats = async (data) => {
  return fetch(`${NEW_HOST_URL}/get-queue-states`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
//Aryshare Webhook registration
export const registerAryshareWebhook = (data) => {
  return axios({
    method: "POST",
    url: `${PUBLISHER_URL}/proxy/ayrshare/hook/webhook`,
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
      "Profile-Key": data.profile,
    },
    data: { ...data, entityId: localStorage.getItem("entityId") },
  })
    .then((response) => response)
    .catch(({ response }) => response);
};

export const regenerateThumbnail = async (data) => {
  return fetch(`${NEW_HOST_URL}/clip/regenerate-thumbnail`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      // Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getAllClipNamingTemplates = async ({ entityId, category }) => {
  return fetch(`${NEW_HOST_URL}/clipNamingTemplate/getalltemplates/${entityId}/${category}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .catch((error) => {
      throw error;
    });
};

export const addClipNamingTemplateIdToStream = async (data) => {
  return fetch(`${NEW_HOST_URL}/clipNamingTemplate/addClipNamingTemplateIdToStream`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  }).then((res) => {
    return res.json();
  });
};

export const sentToClientWebhook = async (payload) => {
  return fetch(`${NEW_HOST_URL}/upload-stream-data`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }).then((res) => {
    return res.json();
  });
};

export const getCloudPreSignedURL = async (data) => {
  return fetch(`${PUBLISHER_URL}/api/v1/cloud.getPresignedUrl`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  }).then((res) => {
    return res.json();
  });
};

export const getDownloadVideo = async (data) => {
  return fetch(`${PUBLISHER_URL}/api/v1/cloud.downloadVideo`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  }).then((res) => {
    return res.json();
  });
};

export const getDownloadVideoStatus = async (data) => {
  return fetch(`${PUBLISHER_URL}/api/v1/downloadHistory.getDownloadConsumption`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  }).then((res) => {
    return res.json();
  });
};

export const getDownloadBulkVideo = async (data) => {
  return fetch(`${PUBLISHER_URL}/api/v1/cloud.downloadBulkVideo`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  }).then((res) => {
    return res.json();
  });
};
